import { PropsWithChildren, createContext, useContext } from 'react';

import type {
  AvailableMetric,
  Treatment,
} from '@spotify/confidence-editor-react';

export type ReportBlockDataContextValue = {
  availableMetrics: AvailableMetric[];
  treatments: Treatment[];
};

const ReportBlockDataContext = createContext<ReportBlockDataContextValue>({
  availableMetrics: [],
  treatments: [],
});

export const ReportBlockDataProvider = ({
  value,
  children,
}: PropsWithChildren<{ value: ReportBlockDataContextValue }>) => (
  <ReportBlockDataContext.Provider value={value}>
    {children}
  </ReportBlockDataContext.Provider>
);

export const useReportBlockData = () => useContext(ReportBlockDataContext);
